<template>
  <div
    class="membership-promo"
  >
    <div class="membership-promo__card">
      <CdrImg
        :aria-hidden="true"
        src="https://public.cloud-dam.rei.com/api/public/content/6celebrate_v3_rgb_web_xs_transparent.jpeg"
      />
      <CdrText
        class="membership-promo__heading membership-promo__heading--larger"
      >
        New members create change
      </CdrText>
      <CdrText
        class="membership-promo__body"
      >
        <CdrLink
          href="/membership"
          @click="handleMembershipLinkClick"
        >
          Join a community
        </CdrLink>
        of 23 million making a different kind of outdoor
        company. Built by members, not investors. Accountable to each
        other, not shareholders. Together, we’re sharing, exploring and
        protecting the places we love, for today and every day.
      </CdrText>
    </div>
    <div class="membership-promo__cards-container">
      <div class="membership-promo__card">
        <CdrText
          class="membership-promo__heading"
        >
          REI Cooperative Action Fund
        </CdrText>
        <CdrText
          class="membership-promo__utility"
        >
          With the purchase of each lifetime membership, we donate $5 to
          the REI Cooperative Action Fund<sup>†</sup>.
        </CdrText>
      </div>
      <div class="membership-promo__card">
        <CdrText
          class="membership-promo__heading"
        >
          Re/Supply
        </CdrText>
        <CdrText
          class="membership-promo__utility"
        >
          Members can trade in &amp; shop gently used gear, giving it new life,
          keeping it out of landfills, and reducing carbon emissions.
        </CdrText>
      </div>
      <div class="membership-promo__card">
        <CdrText
          class="membership-promo__heading"
        >
          Keep your bike ride-ready
        </CdrText>
        <CdrText
          class="membership-promo__utility"
        >
          Tread lighter on the planet. Members save 20% on bike shop services,
          making it easier on your wallet to get out and ride.
        </CdrText>
      </div>
    </div>
    <div class="membership-promo__card membership-promo__card--green">
      <CdrText
        tag="p"
        class="membership-promo__eyebrow"
      >
        — REI CO-OP MEMBERSHIP —
      </CdrText>
      <CdrText
        class="membership-promo__heading--green"
      >
        Join once for just $30. Adventure for life.
      </CdrText>
      <CdrButton
        tag="a"
        modifier="secondary"
        href="/membership"
        @click="handleMembershipLinkClick"
      >
        Make an impact with membership
      </CdrButton>
    </div>
  </div>
</template>

<script>
import {
  CdrText,
  CdrImg,
  CdrLink,
  CdrButton,
} from '@rei/cedar';

export default {
  name: 'MembershipPromo',
  components: {
    CdrText,
    CdrLink,
    CdrImg,
    CdrButton,
  },
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleMembershipLinkClick() {
      if (window && window.metrics) {
        window.metrics.link('cooperative-action:campaign details_post signage_membership promo');
      }
    },
  },
};
</script>

  <style lang="scss">

  .membership-promo {
    max-width: 768px;
    margin: auto;
    margin-top: $cdr-space-two-x;

    @include cdr-sm-mq-up {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: $cdr-space-one-x;
    }

    &__card {
        padding: $cdr-space-three-quarter-x;
        background-color: $cdr-color-background-secondary;
        margin-top: $cdr-space-three-quarter-x;
        margin-bottom: $cdr-space-three-quarter-x;
        border-radius: 8px;

        img {
            background-color: $cdr-color-background-secondary;
            width: 153px;
            height: 158.5px;
        }
    }

    &__cards-container {
        @include cdr-sm-mq-up {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    &__card--green {
        background-color: $cdr-color-background-brand-spruce;
        color: $cdr-color-text-inverse;
        padding-top: $cdr-space-half-x;
        padding-bottom: $cdr-space-one-and-a-half-x;

        a {
            margin-top: $cdr-space-one-x;
        }

        img {
            height: 8px;
            width: 200px;
        }

        @include cdr-sm-mq-up {
            grid-column: 1/3;
        }
    }

    &__eyebrow {
        @include cdr-text-eyebrow-100;
        padding-top: $cdr-space-one-x;
        padding-bottom: $cdr-space-one-x;
        letter-spacing: 4px;
        font-size: 1.4rem;
        font-weight: 600;
    }

    &__heading {
        @include cdr-text-subheading-sans-400;
        color: $cdr-color-text-brand;
        text-wrap: nowrap;
        margin-top: $cdr-space-quarter-x;
        margin-bottom: $cdr-space-quarter-x;
    }

    &__heading--larger {
        @include cdr-text-heading-serif-600;
        margin-top: $cdr-space-half-x;
        margin-bottom: $cdr-space-half-x;
    }

    &__heading--green {
        @include cdr-text-heading-serif-600;
        margin-bottom: $cdr-space-half-x;
    }

    &__utility {
        @include cdr-text-utility-sans-300;
        sup {
            line-height: 1.2rem;
        }
    }

    &__body {
        @include cdr-text-body-300;
        padding-bottom: $cdr-space-one-x;
    }
  }

  </style>
